import { slugify } from '../../../../util'
import React from 'react'

export const RenderTenantList = (props) => {
  const { title, list } = props
  return (
    <wb-accordion-item>
      <wb-accordion-toggle>{title}</wb-accordion-toggle>
      <wb-accordion-section>
        <wb-accordion-mobile-header className="wb-type-heading-xs">
          Close
        </wb-accordion-mobile-header>
        <wb-accordion-content>
          <div className="tenant-body__table">
            <table
              width="100%"
              className="wb-table wb-table--striped wb-table--border-vertical wb-table--border-horizontal wb-type-copy-secondary"
            >
              <thead>
                <tr>
                  <th className="wb-grid-col-mq1-2">Tenant</th>
                  <th className="wb-grid-col-mq1-5">Product Owner</th>
                  <th className="wb-grid-col-mq1-5">Product Manager</th>
                </tr>
              </thead>
              <tbody>
                {list.length ? (
                  list.map((item, i) => {
                    return (
                      <tr key={`${slugify(title)}_${i}`}>
                        <td className="wb-grid-col-mq1-2">
                          <a target="_blank" href={`/#/apps/${item.acronym}`}>
                            {item.acronym.toUpperCase()}
                          </a>
                        </td>
                        <td className="wb-grid-col-mq1-5">{item.po}</td>
                        <td className="wb-grid-col-mq1-5">{item.pm}</td>
                      </tr>
                    )
                  })
                ) : (
                  <tr key={`${slugify(title)}`}>
                    <td
                      colSpan="3"
                      align="center"
                      className="wb-grid-col-mq1-12"
                    >
                      No tenants was found with this property
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </wb-accordion-content>
      </wb-accordion-section>
    </wb-accordion-item>
  )
}
